import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
    title: {
        paddingRight: 10,
        wordWrap: 'break-word',
        whiteSpace: 'nowrap',
    },
    optionButton: {
        borderRadius: 0,
        borderWidth: 1,
        backgroundColor: 'white',
        color: 'black',
    },
    optionButtonSelected: {
        borderRadius: 0,
        borderWidth: 1,
        backgroundColor: 'orange',
        color: 'black',
        "&:hover": {
            backgroundColor: 'orange'
        }
    }
})

const FilterBar = ({
    title = '',
    options = [],
    selectedOption = '',
    onSelectOption = () => null,
    classes,
}) => {
    return <div className='flex justify-start items-center'>
        <div className={classes.title}>
            {title}
        </div>
        <div>
            { options.map(option => (
                <Button
                    key={option.value}
                    variant="outlined"
                    className={
                        selectedOption === option.value
                            ? classes.optionButtonSelected
                            : classes.optionButton
                    }
                    onClick={() => onSelectOption(option.value) }
                >
                    {option.displayText}
                </Button>
            ))}
        </div>
    </div>
}

FilterBar.propTypes = {
    title: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    selectedOptions: PropTypes.string,
    onSelectedOption: PropTypes.func,
}

export default withStyles(styles)(FilterBar)



// WEBPACK FOOTER //
// ./src/components/FilterBar.js